import { useEffect } from "react";
import type { PageProps } from "../pages/Page";
import type { Experiments } from "../hooks/experiments/types";

type ConversationField = { id: string; value: string };
type ZendeskParams = ConversationField[] | (() => void) | undefined;

declare global {
  interface Window {
    zE: (event: string, action: string, params?: ZendeskParams) => void;
  }
}

type ZendeskProps = {
  chatKey: string;
  customerId: string;
  experiments?: Experiments;
};

// Get Zendesk keys from page data props
export const getZendeskKeys = (pageData: PageProps): ZendeskProps | undefined =>
  pageData.scripts?.find(({ metadata }) => metadata.name === "zendesk-chat")
    ?.props as ZendeskProps;

export const ZendeskProvider = ({ chatKey, customerId }: ZendeskProps) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "ze-snippet";
    script.className = "optanon-category-C0003";
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${chatKey}`;
    script.async = true;
    script.addEventListener("load", function () {
      if (window?.zE) {
        window.zE("messenger:on", "open", function () {
          window.zE("messenger:set", "conversationFields", [
            { id: customerId, value: window?.location.href },
          ]);
        });
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [chatKey, customerId]);

  return null;
};
